import UsageIcon from '@mui/icons-material/Create';
import { Box, Button, useTheme } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import React, { useState } from 'react';
import { UsageModal } from '@/components/chord_progression/converter/UsageModal';

type FormState = {
  isOpenUsageModal: boolean;
};

export const Form = (props: {
  progressionsString: string;
  predictedKeys: [string, number][];
  phraseKey: string;
  handleProgressionsStringChange: (
    e: React.ChangeEvent<HTMLInputElement>
  ) => void;
  handleKeyChange: (e: SelectChangeEvent) => void;
}) => {
  const [state, setState] = useState<FormState>({
    isOpenUsageModal: false,
  });

  const handleOpenUsageButtonClick = () => {
    setState({ ...state, isOpenUsageModal: true });
  };

  const handleCloseUsageModal = () => {
    setState({ ...state, isOpenUsageModal: false });
  };

  const theme = useTheme();

  return (
    <Stack spacing={4}>
      <Stack spacing={1} sx={{ alignItems: 'center' }}>
        <TextField
          label="コード進行を入れてね"
          placeholder="FM7 G Em7 Am"
          multiline
          sx={{ width: '100%' }}
          onChange={props.handleProgressionsStringChange}
        />
        <Box>
          <Button
            startIcon={<UsageIcon />}
            size="small"
            sx={{ color: theme.palette.text.secondary }}
            onClick={handleOpenUsageButtonClick}
          >
            コード進行の記法
          </Button>
          <UsageModal
            isOpen={state.isOpenUsageModal}
            handleClose={handleCloseUsageModal}
          />
        </Box>
      </Stack>
      {props.progressionsString ? (
        <FormControl>
          <InputLabel id="key-select-label">キーを選んでね</InputLabel>
          <Select
            labelId="key-select-label"
            label="キーを選んでね"
            value={props.phraseKey}
            onChange={props.handleKeyChange}
          >
            {getKeySelectItem(props.predictedKeys)}
          </Select>
        </FormControl>
      ) : null}
    </Stack>
  );
};

const getKeySelectItem = (predictedKeys: [string, number][]): JSX.Element[] => {
  // 合計コード数を計算する
  let totalChordCounter = 0;
  if (predictedKeys.length) {
    totalChordCounter = predictedKeys
      // コード数を取り出す
      .map(([, counter]) => {
        return counter;
      })
      // 合計する
      .reduce((subTotal, counter) => {
        return subTotal + counter;
      });
  }

  // KeySelectItemを作る
  return (
    predictedKeys
      // コード数が0のキーを除外する
      .filter(([, counter]) => {
        return counter > 0;
      })
      // KeySelectItemを作る
      .map(([key, counter]) => {
        const percentage = Math.round((counter / totalChordCounter) * 100);

        return (
          <MenuItem key={key} value={key}>
            {`${key} (${percentage}%)`}
          </MenuItem>
        );
      })
  );
};
